import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import InstallBanner from '../components/ui/InstallBanner';
import PoweredBy from '../components/common/PoweredBy';
import { ROUTES } from '../constants';
import './DownloadPage.css';

const DownloadPage = () => {
    return (
        <div className="download-page">
            <Header />

            <section className="download-hero">
                <div className="download-hero-container">
                    <h1 className="download-title">Download AzimuthLab</h1>
                    <p className="download-subtitle">
                        Get started with AzimuthLab on your preferred platform. Choose your operating system below.
                    </p>
                </div>
            </section>

            <section className="download-options">
                <div className="download-container">
                    <InstallBanner />
                    <div className="download-cards">
                        {/* Download content will be provided later */}
                    </div>
                </div>
            </section>

            {/* System Requirements section removed as per request */}

            <section className="installation-guide">
                <div className="guide-container">
                    <h2 className="guide-title">Installation Guide</h2>
                    <div className="guide-steps">
                        <div className="guide-step">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3 className="step-title">Download</h3>
                                <p className="step-description">
                                    Click the download button for your operating system above.
                                </p>
                            </div>
                        </div>
                        <div className="guide-step">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3 className="step-title">Install</h3>
                                <p className="step-description">
                                    Run the installer and follow the on-screen instructions.
                                </p>
                            </div>
                        </div>
                        <div className="guide-step">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3 className="step-title">Launch</h3>
                                <p className="step-description">
                                    Open AzimuthLab and log in with your credentials.
                                </p>
                            </div>
                        </div>
                        <div className="guide-step">
                            <div className="step-number">4</div>
                            <div className="step-content">
                                <h3 className="step-title">Get Started</h3>
                                <p className="step-description">
                                    Start managing your inventory efficiently!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="download-cta">
                <div className="cta-container">
                    <h2 className="cta-title">Need Help?</h2>
                    <p className="cta-description">
                        If you encounter any issues during installation, please contact our support team.
                    </p>
                    <div className="cta-actions">
                        <Link to={ROUTES.LOGIN} className="btn-cta-primary">
                            Go to Login
                        </Link>
                        <a href="#" className="btn-cta-secondary">
                            Contact Support
                        </a>
                    </div>
                </div>
            </section>

            <Footer />
            <PoweredBy />
        </div>
    );
};

export default DownloadPage;
